import { gql } from '@/__generated__';

export const countProductsDocument = gql(/* GraphQL */ `
  query CountProducts($where: ProductWhereInput!) {
    countProducts(where: $where)
  }
`);
